(function () {

  /* ================== CONFIG / CONSTANTS ================== */

  const CARD_SELECTOR = ".t4s-product, .product-card, .prd, [data-product-card], [data-zapiet-card]";
  const PREDICTIVE_ITEM_SELECTOR = ".t4s-search-fullwidth__item, .t4s-mini-search__content .t4s-product, [data-results-search] .t4s-product";
  const SECTIONS_TO_OBSERVE = [
    ".id_recently_viewed",
    ".id_product-recommendations",
    ".product-recommendations",
    "#product-recommendations",
    "[data-section-type='product-recommendations']",
    ".t4s-mini-search__content",
    "[data-results-search]",
    ".predictive-search",
    ".search-results"
  ];

  // Collection-specific configurations
  const COLLECTION_CONFIGS = {
    '/collections/fabulous-cakes': {
      batchSize: 10,
      batchDelay: 100,
      lazyLoad: true
    },
    'default': {
      batchSize: 10,
      batchDelay: 300,
      lazyLoad: false
    }
  };

  function getCollectionConfig() {
    const path = window.location.pathname;
    return COLLECTION_CONFIGS[path] || COLLECTION_CONFIGS['default'];
  }

  const PAGE_PATH = window.location.pathname;
  const IS_RESTRICTED_PAGE = ["/cart", "/checkout", "/checkouts", "/thank_you"].some(p => PAGE_PATH.includes(p));
  if (IS_RESTRICTED_PAGE) return;

  /* ⛔ STOP script on PDP to fix timeout/500 issue */
  if (PAGE_PATH.includes("/products/")) return;

  const CARD_STATE_CACHE = new WeakMap();
  let zapietLock = false;
  const DEBUG = false;
  let isInitialized = false;
  let evaluationInProgress = false;

  // Zapiet data cache
  let zapietDataCache = null;
  let zapietCacheTime = 0;
  const CACHE_DURATION = 30000;

  function logDebug(...args) { if (DEBUG) console.log("[COLLECTION BADGE]", ...args); }
  function lockZapietUpdates(temp=false,ms=800){zapietLock=true;if(temp)setTimeout(()=>{zapietLock=false},ms)}

  /* ================== STYLES ================== */
  function injectBadgeStyles(){
      if(document.getElementById("zapiet-card-badges"))return;
      const style=document.createElement("style");
      style.id="zapiet-card-badges";
      style.innerHTML=`
      ${CARD_SELECTOR}{position:relative;isolation:isolate;}
      .zapiet-badge{font-weight:500;padding:4px 6px;font-size:9px;position:absolute;top:8px;left:0;border-radius:6px;z-index:10;color:#fff;pointer-events:none;min-width:64px;text-align:center;box-shadow:0 2px 6px rgba(0,0,0,.18);}
      .badge-loading{background:rgba(120,120,120,.5);}
      .badge-available{background:rgba(0,207,131,.97);}
      .badge-sold-out,.badge-unavailable{background:rgba(128,128,128,.92);}
      .badge-partially-available{background:#FF7A00;}
      .badge-order-now{background:#8cc8ff;color:#00324d;}
      .zapiet-disabled{opacity:.38;pointer-events:none;}
      .no-click{pointer-events:none!important;cursor:default!important;}
      `;
      document.head.appendChild(style);
  }

  /* ================== HELPERS ================== */

  const isPredictiveCard=card=>!!(card?.closest(".t4s-mini-search__content")||card?.closest("[data-results-search]")||card?.classList.contains("t4s-search-fullwidth__item"));

  function ensureBadge(card){
      if(!card)return null;
      let b=card.querySelector(".zapiet-badge");
      if(!b){b=document.createElement("div");b.className="zapiet-badge badge-loading";b.textContent="…";card.prepend(b)}
      return b;
  }

  const setBadge=(card,text,cls)=>{if(zapietLock&&cls!=="badge-loading")return;const b=ensureBadge(card);if(b){b.textContent=text;b.className="zapiet-badge "+cls;}}

  function paintLoadingBadges(scope=document){
    try{
      const config=getCollectionConfig();
      const cards=[...scope.querySelectorAll(CARD_SELECTOR)];
      if(config.lazyLoad){
          const io=new IntersectionObserver(e=>{e.forEach(i=>{if(i.isIntersecting){ensureBadge(i.target);io.unobserve(i.target)}})},{rootMargin:"200px"});
          cards.forEach(c=>io.observe(c));
      }else cards.forEach(c=>ensureBadge(c));
    }catch(e){}
  }

  function disableProduct(c,l){
    if(isPredictiveCard(c))return;
    c.classList.add("zapiet-disabled");
    const btn=c.querySelector("form[action*='/cart'] button[type='submit']");
    if(btn){if(!btn.hasAttribute("data-original-label"))btn.setAttribute("data-original-label",btn.innerText.trim());btn.disabled=true;btn.innerText=l;}
    const a=c.querySelector("a");if(a){a.classList.add("no-click");a.style.pointerEvents="none";}
  }

  function enableProduct(c){
    c.classList.remove("zapiet-disabled");
    const btn=c.querySelector("form[action*='/cart'] button[type='submit']");
    if(btn){btn.disabled=false;btn.innerText=btn.getAttribute("data-original-label")||"Add to Cart";}
    const a=c.querySelector("a");if(a){a.classList.remove("no-click");a.style.pointerEvents=""}
  }

  /* ================== ZAPIET STATE/CACHE ================== */

  function zapietState(){return{r:ZapietEats?.getSelectedRestaurant(),m:ZapietEats?.getSelectedMenu(),dRaw:ZapietEats?.getSelectedDate(),vm:ZapietWidgetConfig?.variant_metafields}}

  const toLocalISO=d=>{try{const dt=new Date(d);return`${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,"0")}-${String(dt.getDate()).padStart(2,"0")}`}catch{return null}}
  const getInventoryDateISO=()=>toLocalISO(ZapietEats?.getLocationInventoryDate()||ZapietEats?.getSelectedDate())
  const getLocalTodayISO=()=>toLocalISO(new Date())

  function getCachedZapietData(){
    const now=Date.now();
    if(zapietDataCache && now-zapietCacheTime<CACHE_DURATION)return zapietDataCache;
    const{r,m,vm}=zapietState();if(!r||!m||!vm)return null;
    const selectedDate=getInventoryDateISO(),todayISO=getLocalTodayISO();
    const delivery=ZapietEats.getDeliveryOption()==="pickup"?"store_pickup":"local_delivery";
    const menuCfg=m?.config?.[delivery]||{},restr=menuCfg.product_date_restrictions||[],schedule=menuCfg.schedule||null;
    const menuIds=[];m?.menu_sections?.forEach(s=>s?.menu_section_items?.forEach(i=>i?.product?.variant_id&&menuIds.push(String(i.product.variant_id))))
    zapietDataCache={r,m,vm,selectedDate,todayISO,restrictions:restr,schedule,menuSet:new Set(menuIds)}
    zapietCacheTime=now;return zapietDataCache;
  }
  const clearZapietCache=()=>{zapietDataCache=null;zapietCacheTime=0}

  /* ================== SOLD OUT/RESTRICTED LOGIC ================== */

  function isVariantSoldOut(vm,r,m,d,id,check){if(!check)return false;const v=vm?.[id];if(!v)return false;const inv=v[`limits.${r}.${m}.${d}`];return inv&&(inv.toggled_off||inv.remaining<=0)}
  function isVariantRestricted(restr,id,date,sched){return restr?.some(r=>String(r.variant_id)==String(id)&&((r.restricted_dates?.includes(date))||(r.start_date<=date&&r.end_date>=date)))}

  function parseVariantIds(c){
      let ids=[],single=null,avail=true;
      try{
        const inline=c.getAttribute("data-variant-ids");
        if(inline)ids=JSON.parse(inline.replace(/'/g,'"')).map(String);
        if(!ids.length){
          const opt=c.getAttribute("data-product-options");
          if(opt){const p=JSON.parse(opt);if(p.VariantFirstID)single=String(p.VariantFirstID);if(p.available===false)avail=false;if(p.variants)ids=p.variants.map(v=>String(v.id))}
        }
      }catch{}
      return{ids:ids.length?ids:(single?[single]:[]),shopifyAvailable:avail}
  }

  function applyCardStateIfChanged(card,status,cls,disable){
    const memo=`${status}|${cls}|${disable?1:0}`,old=CARD_STATE_CACHE.get(card);
    if(memo===old)return;CARD_STATE_CACHE.set(card,memo);
    queueMicrotask(()=>{setBadge(card,status,cls);disable?disableProduct(card,status):enableProduct(card);})
  }

  /* ================== PER CARD EVAL ================== */

  function evaluateCard(c,vm,rst,sched,r,m,date,today,set){
    const {ids,shopifyAvailable}=parseVariantIds(c);
    if(!ids.length||!shopifyAvailable)return applyCardStateIfChanged(c,"UNAVAILABLE","badge-unavailable",true);

    const future=date>today,check=!future;
    const sold=ids.map(id=>isVariantSoldOut(vm,r,m,date,id,check));
    const restr=ids.map(id=>isVariantRestricted(rst,id,date,sched));
    const anyAv=ids.some((_,i)=>!sold[i]&&!restr[i]),allSold=sold.every(Boolean),allRestr=restr.every(Boolean);
    let status="IN STOCK",cls="badge-available",disable=false;

    if(future){
      if(allRestr){status="UNAVAILABLE";cls="badge-unavailable";disable=true}
      else if(!allRestr&&!allSold&&!anyAv){status="LIMITED";cls="badge-partially-available"}
    }else{
      if(allSold){status="SOLD OUT TODAY";cls="badge-sold-out";disable=true}
      else if(allRestr){status="UNAVAILABLE";cls="badge-unavailable";disable=true}
      else if((sold.includes(true)||restr.includes(true))&&anyAv){status="LIMITED";cls="badge-partially-available"}
    }
    applyCardStateIfChanged(c,status,cls,disable)
  }

  /* ================== 🔥 NEW — evaluate only new items ================== */
  function evaluateNewCards(cards){
    if(!cards?.length)return;
    const data=getCachedZapietData();
    if(!data){cards.forEach(c=>ensureBadge(c));scheduleEvaluate();return;}
    const {r,m,vm,selectedDate,todayISO,restrictions,schedule,menuSet}=data;
    if(!selectedDate)return cards.forEach(c=>applyCardStateIfChanged(c,"ORDER NOW","badge-order-now",false));
    cards.forEach(c=>evaluateCard(c,vm,restrictions,schedule,r.id,m.id,selectedDate,todayISO,menuSet));
  }

  /* ================== BATCH ALL ================== */

  function evaluateAllCards(scope=document){
    if(evaluationInProgress)return;evaluationInProgress=true;
    const cards=[...scope.querySelectorAll(CARD_SELECTOR)];
    const data=getCachedZapietData();
    if(!data){paintLoadingBadges(scope);evaluationInProgress=false;return scheduleEvaluate();}
    const {r,m,vm,selectedDate,todayISO,restrictions,schedule,menuSet}=data;
    if(!selectedDate){cards.forEach(c=>applyCardStateIfChanged(c,"ORDER NOW","badge-order-now",false));evaluationInProgress=false;return;}

    const cfg=getCollectionConfig(),batch=cfg.batchSize,delay=cfg.batchDelay;
    let idx=0;
    (function next(){
      const slice=cards.slice(idx,idx+batch);
      requestAnimationFrame(()=>slice.forEach(c=>evaluateCard(c,vm,restrictions,schedule,r.id,m.id,selectedDate,todayISO,menuSet)))
      idx+=batch;if(idx<cards.length)setTimeout(next,delay);else evaluationInProgress=false;
    })();
  }

  /* ================== INIT WAIT ================== */
  function waitForZapietEats(cb,i=0){
    if(ZapietEats?.getSelectedMenu&&ZapietWidgetConfig?.variant_metafields)return cb();
    if(i<60)return setTimeout(()=>waitForZapietEats(cb,i+1),250);
    paintLoadingBadges();
  }

  /* ================== OBSERVERS ================== */

  let raf=null,deb=null;
  function scheduleEvaluate(){
    if(deb)clearTimeout(deb);if(raf)cancelAnimationFrame(raf);
    deb=setTimeout(()=>raf=requestAnimationFrame(()=>evaluateAllCards()),150);
  }

  /* 🔥 NEW — detects lazy-loaded product cards instantly */
  function observeCardAdditions(){
    new MutationObserver(muts=>{
      const newly=[];
      muts.forEach(m=>m.addedNodes.forEach(n=>{
        if(n.nodeType!==1)return;
        if(n.matches?.(CARD_SELECTOR))newly.push(n);
        else if(n.querySelectorAll?.(CARD_SELECTOR).length)newly.push(...n.querySelectorAll(CARD_SELECTOR));
      }));
      if(newly.length){
        newly.forEach(c=>ensureBadge(c));
        evaluateNewCards(newly); // instant update
      }
    }).observe(document.body,{childList:true,subtree:true})
  }

  function applyPredictiveBadges(){/* unchanged */} 
  function observePredictive(){applyPredictiveBadges(); new MutationObserver(()=>setTimeout(applyPredictiveBadges,100)).observe(document.body,{childList:true,subtree:true})}

  /* ================== INIT ================== */

  function init(){
    injectBadgeStyles();
    const start=()=>waitForZapietEats(()=>{
      isInitialized=true;
      paintLoadingBadges(document);
      evaluateAllCards();
      observeCardAdditions();
      observePredictive();
      setTimeout(()=>evaluateAllCards(),2000);
    });

    'requestIdleCallback'in window?requestIdleCallback(start,{timeout:2000}):setTimeout(start,800);
  }

  document.readyState==="loading"?document.addEventListener("DOMContentLoaded",init):init();

})();
